import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormArray,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  NODE_EDIT_TAB_COMPONENT,
  NodeEditTab,
  SelectedNodeForEdit,
} from 'src/app/shared/flow-chart/flow-chart.model';
import { ConditionNodeData, OperatorsMap } from '../../../node-edit.type';
import { WorkflowModel } from '@models/workflow.model';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UiButtonComponent } from '@ui';

@Component({
  selector: 'edit-condition',
  imports: [
    MatSelect,
    MatOption,
    UiButtonComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-condition.component.html',
  styleUrl: './edit-condition.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditConditionComponent,
    },
  ],
})
export class EditConditionComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<ConditionNodeData>>();
  public disableForm = input<boolean>(false);

  public form!: UntypedFormGroup;

  public readonly operators = Object.keys(OperatorsMap) as WorkflowModel.Operators[];

  public readonly operatorsMap = OperatorsMap;

  public readonly operatorsEnum = WorkflowModel.Operators;

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService,
  ) { }

  public ngOnInit(): void {
    const validations = this.selectedNodeForEdit()?.data?.validations ?? [{}];

    this.form = this.fb.group({
      validations: this.fb.array(
        validations.map((v) => this.createValidationGroup(v)),
      ),
      name: [
        this.selectedNodeForEdit()?.data?.name ??
        this.translateService.instant('FLOW_CHART.NODES.CONDITION.NAME'),
        [Validators.required],
      ],
    });
  }

  public get validations(): UntypedFormArray {
    return this.form.get('validations') as UntypedFormArray;
  }

  public createValidationGroup(
    validation?: WorkflowModel.Validation,
  ): UntypedFormGroup {
    return this.fb.group({
      path: [validation?.path ?? ''],
      op: [validation?.op ?? WorkflowModel.Operators.Equal],
      value: [validation?.value ?? ''],
    });
  }

  public addValidation(): void {
    this.validations.push(this.createValidationGroup());
  }

  public removeValidation(index: number): void {
    this.validations.removeAt(index);
  }
}
